import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const WidgetContainer = styled.div`
    width: 100%;
`;

export const ContainerLabel = styled.p<{ isTitleAdjacent }>`
    margin: 0;
    position: relative;
    bottom: ${({ isTitleAdjacent }) => (isTitleAdjacent ? "2px" : "0")};
    ${setFontVariant("subtitle2", colorsPalettes.carbon[250])};
    padding-bottom: ${({ isTitleAdjacent }) => (isTitleAdjacent ? "22px" : "16px")};
    @media (max-width: 1400px) {
        bottom: ${({ isTitleAdjacent }) => (isTitleAdjacent ? "6px" : "0")};
        padding-bottom: 16px;
    }
`;

export const WidgetHeader = styled(FlexRow)<{ isSubTitleAdjacent }>`
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${({ isSubTitleAdjacent }) => (isSubTitleAdjacent ? "0" : "16px")};

    & > * {
        width: fit-content !important;
    }

    @media (max-width: 1400px) {
        padding-bottom: ${({ isSubTitleAdjacent }) => (isSubTitleAdjacent ? "0" : "8px")};
    }
`;

export const WidgetTitle = styled.h6`
    margin: 0;
    ${setFontVariant("h6", colorsPalettes.carbon[500])};
    @media (max-width: 1400px) {
        ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    }
`;

export const TableWrapper = styled.div<{
    marginBottom?: number;
}>`
    margin: 0 auto ${(props) => props.marginBottom ?? 16}px;
`;

export const GridsContainer = styled.div`
    width: 100%;
    padding: 8px;
    border-radius: 6px;
    box-sizing: border-box;
    background-color: rgb(236, 241, 255);
`;

export const GridsTable = styled.ul<{
    columns: number;
    gridsGap: number;
    gridTemplateColumns?: string;
}>`
    display: grid;
    grid-template-columns: ${(props) => props.gridTemplateColumns || [...Array(props.columns)].map(() => "1fr ")};
    gap: ${(props) => props.gridsGap}px;
    margin: auto;
`;
